export default [{
		//新增员工信息
		path: '/IncumbentEmployeeEdit',
		name: 'IncumbentEmployeeEdit',
		component: (resolve) => require(['@/pages/StaffPage/edit_I.vue'], resolve)
	}, {
		//附件
		path: '/test',
		name: 'test',
		// component: (resolve) => require(['@/pages/projectPage/intelligentMatch/intelligentMatch.vue'], resolve)
		// component: (resolve) => require(['@/pages/test.vue'], resolve)
	}, {
		//人员编辑
		path: '/personCertificateEdit',
		name: 'personCertificateEdit',
		component: (resolve) => require(['@/pages/certificateManger/person/edit.vue'], resolve)
	},
	{
		//基本资料
		path: '/baseInfo',
		name: 'baseInfo',
		component: (resolve) => require(['@/pages/baseInfo.vue'], resolve)
	},
	{
		//投标编辑
		path: '/tenderProjectEdit',
		name: 'tenderProjectEdit',
		component: (resolve) => require(['@/pages/projectPage/bidManagement/edit_T.vue'], resolve)
	},
	{
		//中标编辑
		path: '/winningBidProjectEdit',
		name: 'winningBidProjectEdit',
		component: (resolve) => require(['@/pages/projectPage/bidManagement/edit_W.vue'], resolve)
	},
	{
		//在建编辑
		path: '/underProjectEdit',
		name: 'underProjectEdit',
		component: (resolve) => require(['@/pages/projectPage/projectManagement/edit_U.vue'], resolve)
	},
	{
		//竣工编辑
		path: '/completionProjectEdit',
		name: 'completionProjectEdit',
		component: (resolve) => require(['@/pages/projectPage/projectManagement/edit_C.vue'], resolve)
	},
	{
		// 收款合同
		path: '/receiptContractEdit',
		name: 'receiptContractEdit',
		component: (resolve) => require(['@/pages/projectPage/contractManagement/edit_R.vue'], resolve)
	},
	{
		// 付款合同
		path: '/paymentContractEdit',
		name: 'paymentContractEdit',
		component: (resolve) => require(['@/pages/projectPage/contractManagement/edit_P.vue'], resolve)
	},
	{
		//企业证书
		path: '/companyCertificateEdit',
		name: 'companyCertificateEdit',
		component: (resolve) => require(['@/pages/certificateManger/company/edit.vue'], resolve)
	},
	{
		//数字证书
		path: '/digitalCertificateEdit',
		name: 'digitalCertificateEdit',
		component: (resolve) => require(['@/pages/certificateManger/digital/edit.vue'], resolve)
	},{
		//智能匹配
		path: '/PersonSmartMatch',
		name: 'PersonSmartMatch',
		component: (resolve) => require(['@/pages/certificateManger/smartmatch/intelligentMatch.vue'], resolve)
	},{
		//人员匹配
		path: '/PersonMatch',
		name: 'PersonMatch',
		component: (resolve) => require(['@/pages/certificateManger/smartmatch/personMatch.vue'], resolve)
	},{
		//用户信息
		path: '/setUsetInfo',
		name: 'setUsetInfo',
		meta: {
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/rootSet/setUserInfo.vue'], resolve)
	},{
		//用户管理
		path: '/userManagment',
		name: 'userManagment',
		component: (resolve) => require(['@/pages/rootSet/userManagment.vue'], resolve)
	},
	{
		// 添加用户信息
		path: '/editUserInfo',
		name: 'editUserInfo',
		component: (resolve) => require(['@/pages/rootSet/addUserInfo.vue'], resolve)
	},
	{
		// 角色信息
		path: '/setRoleInfo',
		name: 'setRoleInfo',
		meta: {
			keepAlive:true,
		},
		component: (resolve) => require(['@/pages/rootSet/setRoleInfo.vue'], resolve)
	},
	{
		// 查看角色
		path: '/viewRoleInfo',
		name: 'viewRoleInfo',
		component: (resolve) => require(['@/pages/rootSet/viewRoleInfo.vue'], resolve)
	},
	{
		// 编辑角色
		path: '/editRoleInfo',
		name: 'editRoleInfo',
		component: (resolve) => require(['@/pages/rootSet/editRoleInfo.vue'], resolve)
	},
	{
		// 新增角色
		path: '/addRoleInfo',
		name: 'addRoleInfo',
		component: (resolve) => require(['@/pages/rootSet/addRoleInfo.vue'], resolve)
	},
	{
		// 编辑角色
		path: '/ProcessAuditSet',
		name: 'ProcessAuditSet',
		component: (resolve) => require(['@/pages/systemSetup/processAuditSet.vue'], resolve)
	},
	{
		// 部门信息
		path: '/DepartmentInfo',
		name: 'DepartmentInfo',
		component: (resolve) => require(['@/pages/systemSetup/department.vue'], resolve)
	},
]


// WEBPACK FOOTER //
// ./src/router/map/sxm.js